import {
  Callout,
  CommandBarButton,
  DirectionalHint,
  Stack,
} from '@fluentui/react';
import React from 'react';
import { DetailsCallout } from './DetailsCallout';
import { useStyles } from './index.styles';
import { LookupTravelerSearch_lookupTravelerSearch_nodes } from '../__generated__/LookupTravelerSearch';

export interface TravelerLookUpCalloutProps {
  data: LookupTravelerSearch_lookupTravelerSearch_nodes[];
  onDismiss?: () => void;
  targetID: string;
  onSelect: (value: LookupTravelerSearch_lookupTravelerSearch_nodes) => void;
  lookUpCalloutWidth?: number;
  onAddNewTraveler?: () => void;
  isAddNewAvailable: boolean;
}

export const TravelerLookUpCallout: React.FC<TravelerLookUpCalloutProps> = ({
  onDismiss,
  data,
  targetID,
  onSelect,
  lookUpCalloutWidth,
  onAddNewTraveler,
  isAddNewAvailable,
}) => {
  const styles = useStyles();
  if (!data?.length) return null;

  return (
    <Callout
      onDismiss={onDismiss}
      gapSpace={10}
      isBeakVisible={false}
      className={styles.callout}
      directionalHint={DirectionalHint.bottomLeftEdge}
      target={targetID}
      style={{ width: lookUpCalloutWidth }}
    >
      <Stack className={styles.searchAreaContainer}>
        {isAddNewAvailable && (
          <CommandBarButton
            styles={{ root: { height: 50 } }}
            iconProps={{ iconName: 'add' }}
            text="Add new traveler"
            onClick={onAddNewTraveler}
          />
        )}
        {!!data.length ? (
          <Stack>
            {data?.map((item, index) => {
              const detailsTargetId = `details${item.id
                ?.replace(/-+/g, '')
                .trim()}`;
              return (
                <DetailsCallout
                  onSelect={onSelect}
                  onDismiss={onDismiss}
                  data={item}
                  key={index.toString()}
                  detailsTargetId={detailsTargetId}
                />
              );
            })}
          </Stack>
        ) : (
          <>
            {isAddNewAvailable && (
              <CommandBarButton
                styles={{ root: { height: 50 } }}
                iconProps={{ iconName: 'add' }}
                text="Add new traveler"
                onClick={onAddNewTraveler}
              />
            )}
          </>
        )}
      </Stack>
    </Callout>
  );
};
